/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The SupplyAppointmentResponse model module.
* @module model/SupplyAppointmentResponse
* @version 2020-12-7
*/
export default class SupplyAppointmentResponse {
    /**
    * Constructs a new <code>SupplyAppointmentResponse</code>.
    * 供給予約
    * @alias module:model/SupplyAppointmentResponse
    * @class
    * @param userId {Number} ユーザーID
    * @param userName {String} ユーザーネーム
    * @param time {Number} 予約の日付
    * @param reason {String} 予約の理由
    */

    constructor(userId, userName, time, reason) {
        
        
        this['userId'] = userId;
        this['userName'] = userName;
        this['time'] = time;
        this['reason'] = reason;
        
    }

    /**
    * Constructs a <code>SupplyAppointmentResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/SupplyAppointmentResponse} obj Optional instance to populate.
    * @return {module:model/SupplyAppointmentResponse} The populated <code>SupplyAppointmentResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SupplyAppointmentResponse();
                        
            
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'Number');
            }
            if (data.hasOwnProperty('userName')) {
                obj['userName'] = ApiClient.convertToType(data['userName'], 'String');
            }
            if (data.hasOwnProperty('time')) {
                obj['time'] = ApiClient.convertToType(data['time'], 'Number');
            }
            if (data.hasOwnProperty('reason')) {
                obj['reason'] = ApiClient.convertToType(data['reason'], 'String');
            }
        }
        return obj;
    }

    /**
    * ユーザーID
    * @member {Number} userId
    */
    'userId' = undefined;
    /**
    * ユーザーネーム
    * @member {String} userName
    */
    'userName' = undefined;
    /**
    * 予約の日付
    * @member {Number} time
    */
    'time' = undefined;
    /**
    * 予約の理由
    * @member {String} reason
    */
    'reason' = undefined;




}
